import { render } from "./ResidenceModal.vue?vue&type=template&id=476a1c70"
import script from "./ResidenceModal.vue?vue&type=script&lang=js"
export * from "./ResidenceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__